import { render, staticRenderFns } from "./elModal.vue?vue&type=template&id=476bfda2"
import script from "./elModal.vue?vue&type=script&lang=js"
export * from "./elModal.vue?vue&type=script&lang=js"
import style0 from "./elModal.vue?vue&type=style&index=0&id=476bfda2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports